import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class TabSessionService {
	private sessionIdKey = 'tabSessionId';
	private sessionId: string;

	constructor () {
		this.initializeSession();
	}

	private initializeSession (): void {
		let sessionId = sessionStorage.getItem(this.sessionIdKey);

		if (!window.name) {
			sessionId = this.generateRandomId();
			window.name = sessionId;
		} else {
			sessionId = window.name;
		}
		sessionStorage.setItem(this.sessionIdKey, sessionId);
		this.sessionId = sessionId;
	}

	private generateRandomId (): string {
		return Math.random().toString(36).substring(2, 9) + '-' + Date.now();
	}

	getSessionId (): string {
		return this.sessionId;
	}
}
